export const PRODUCTS = [
    {
      id: 1,
      name: "Training",
      price_cents: 438000,
      price_id: "price_1REwR7Gygx7EG5d7ZMwNEuxP",
      image_url: "./product_logo.JPG",
      date: "July 15–28",
      description: "Kids with training",
    },
    {
      id: 2,
      name: "General Accompany",
      price_cents: 328000,
      price_id: "price_1REwT2Gygx7EG5d7yTyFjtvH",
      image_url: "./product_logo.JPG",
      date: "July 15–28",
      description: "General Accompany",
    },
    {
      id: 3,
      name: "Senior Accompany",
      price_cents: 278000,
      price_id: "price_1REwUzGygx7EG5d744EMP9nV",
      image_url: "./product_logo.JPG",
      date: "July 15–28",
      description: "Senior Accompany",
    },
    {
      id: 4,
      name: "Baby Accompany",
      price_cents: 128000,
      price_id: "price_1RKDrzGygx7EG5d7fYxD5KXS",
      image_url: "./product_logo.JPG",
      date: "July 15–28",
      description: "Baby Accompany",
    },
  ];
  